import { atom } from "jotai";
import type { Stop } from "../types";

export const expandedStopRootsAtom = atom<Set<string>>(new Set<string>());

export const stopLocationsByRootAtom = atom<
  Map<string, { tpid: string; stops: Stop[] }>
>(new Map<string, { tpid: string; stops: Stop[] }>());

export const stopLocationsInflightAtom = atom<Map<string, Promise<Stop[]>>>(
  new Map<string, Promise<Stop[]>>()
);
